import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdListAlt, MdWhatsapp } from "react-icons/md";
import logo_worded from "../assets/logo_worded_only.png"

export default function IntroPara() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection intro-modern-wrap bg-surface">
      <div className="container">
        <div
          className="intro-modern-card"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="140"
        >
          <div
            className="intro-modern-main intro-fade-up"
            data-aos="fade-right"
            data-aos-duration="950"
          >
            <p className="intro-modern-text text-muted m-0">
              <p className="text-primary font-semi-bold" style={{fontSize:"22px"}} >
                Trusted supply of Steel, Waterproofing and Terrazzo solutions tailored for modern construction needs.
              </p> 
              <p className="" style={{fontSize:"20px"}}>
                Based in Dar es Salaam Tanzania, we support contractors, developers, institutions and
              homeowners with reliable materials, expert guidance and responsive delivery coordination helping
              projects move forward with speed, resilience and confidence.
              </p>
            </p>
          </div>

          <div
            className="intro-modern-cta intro-fade-down"
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay="160"
          >
            <button
              className="btn btn-padded btn-outline-primary btn-rounded"
              onClick={() => appContext.navTo({ item: "request_quote" })}
            >
              <MdListAlt size={22} /> Request a Quote
            </button>

            <button
              className="btn btn-padded btn-primary btn-rounded"
              onClick={() => window.open("https://wa.me/255654253235", "_blank")}
            >
              <MdWhatsapp size={22} /> Chat on WhatsApp
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .intro-modern-wrap {
          padding: 72px 0;
          background: radial-gradient(circle at 90% 12%, rgba(1, 155, 210, 0.12), transparent 36%),
            linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
        }

        .intro-modern-card {
          border-radius: 20px;
          border: 1px solid rgba(1, 155, 210, 0.2);
          background: rgb(255, 255, 255);
          box-shadow: var(--shadow1);
          padding: 24px;
        }

        .intro-modern-main {
          max-width: 920px;
          margin: 0 auto;
          text-align: center;
        }

        .intro-modern-eyebrow {
          font-size: 12px;
          letter-spacing: 1.3px;
          color: var(--secondaryColor);
          margin-bottom: 8px;
        }

        .intro-modern-title {
          font-size: clamp(28px, 4vw, 46px);
          line-height: 1.18;
          margin-bottom: 10px;
        }

        .intro-modern-text {
          font-size: 17px;
          line-height: 1.78;
          opacity: 0.9;
        }

        .intro-modern-cta {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .intro-fade-up {
          animation: introFadeUp 0.75s ease both;
        }

        .intro-fade-down {
          animation: introFadeDown 0.75s ease both;
          animation-delay: 0.15s;
        }

        @keyframes introFadeUp {
          from {
            opacity: 0;
            transform: translateY(18px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes introFadeDown {
          from {
            opacity: 0;
            transform: translateY(-18px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 767px) {

          .intro-modern-card {
            border-radius: 14px;
            padding: 18px;
          }

          .intro-modern-text {
            font-size: 15px;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .intro-fade-up,
          .intro-fade-down {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
